import { Box, ColorOptions, Spacer, TextNew } from '@jfs/ui-new'
import { FlatList } from 'react-native'
import styles from './styles'

const capitalizeTxnDetailsKeys: any = {
  name: 'Name',
  mid: 'MID',
  mobile: 'Mobile',
  vpa: 'VPA',
  tid: 'TID',
}

export const TextLayout = ({ title, data }) => {
  if (!data) {
    return null
  }
  const keys = data ? Object?.keys(data) : []
  const values = data ? Object?.values(data) : []
  const finalData: Array<any> = []

  keys?.map((item, index) => {
    const retData = {
      key: item,
      value: values[index],
    }
    finalData.push(retData)
  })
  const renderListItem = ({ item }: { item: any; index: number }) => {
    if (item?.value?.length === 0 || item?.value === 'NA') {
      return null
    }
    return (
      <Box {...styles.listItemContainer}>
        <Box flex={0.4}>
          <TextNew fontFamily={'jiotype-medium'} color={'BLACK_75'} fontSize={12} numberOfLines={1}>
            {capitalizeTxnDetailsKeys[item.key]}
          </TextNew>
        </Box>
        <Spacer size={16} direction={'vertical'} />
        <Box flex={0.5}>
          <TextNew fontFamily={'jiotype-bold'} fontSize={12} numberOfLines={2} color={'BLACK_21'} textAlign={'right'}>
            {item?.value !== 'undefined' ? String(item?.value ?? 'NA') : 'NA'}
          </TextNew>
        </Box>
      </Box>
    )
  }
  return (
    <Box pv={8} ph={5}>
      <TextNew fontFamily="jiotype-bold" color={'BLACK_21'} fontSize={18}>
        {title}
      </TextNew>
      <Spacer size={12} direction={'vertical'} />
      <Box
        bg={'#0070B6' as ColorOptions}
        w={40}
        h={4}
        borderRadius={8}
        borderWidth={1}
        borderColor={'#0070B6' as ColorOptions}
      />
      <Spacer size={32} direction={'vertical'} />
      <FlatList data={finalData} renderItem={renderListItem} />
    </Box>
  )
}
